export default __webpack_public_path__ + "static/media/favicon.62a25297.png";